const blockDistribution = {
  init() {
    blockDistribution.handleVideo();
  },
  handleVideo() {
    const videoEl = document.querySelector(".dist-video__main");

    if (!videoEl) {
      return;
    }

    let windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
    if (windowWidth > 900) {
      blockDistribution.addSourceToVideo(videoEl, videoEl.dataset.desktop);
    } else {
      blockDistribution.addSourceToVideo(videoEl, videoEl.dataset.mobile);
    }
  },

  addSourceToVideo(videoEl, src) {
    const source = document.createElement("source");
    source.src = src;
    videoEl.appendChild(source);

    document
      .querySelector(".dist-video__poster")
      .addEventListener("click", () => {
        videoEl.play();
        document.querySelector(".dist-video").classList.add("playing");
      });
  },
};

export default blockDistribution;
